export default __webpack_public_path__ + "static/Itai David-277d1ebc4c2fd86bf5207cad515ac3c3.png";